import { render, staticRenderFns } from "./CopyToClipboard.vue?vue&type=template&id=8a58e10c&scoped=true&"
import script from "./CopyToClipboard.vue?vue&type=script&lang=ts&"
export * from "./CopyToClipboard.vue?vue&type=script&lang=ts&"
import style0 from "./CopyToClipboard.vue?vue&type=style&index=0&id=8a58e10c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a58e10c",
  null
  
)

export default component.exports